import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "models-table-wrapper" }
const _hoisted_2 = { class: "segmented-control-wrapper" }
const _hoisted_3 = { class: "segmented-control" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "table-scroll" }
const _hoisted_6 = { class: "models-table" }
const _hoisted_7 = {
  key: 0,
  class: "sort-arrow"
}
const _hoisted_8 = {
  key: 0,
  class: "sort-arrow"
}
const _hoisted_9 = {
  key: 0,
  class: "sort-arrow"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 0,
  class: "sort-arrow"
}
const _hoisted_12 = { class: "col-model" }
const _hoisted_13 = { class: "col-provider" }
const _hoisted_14 = { class: "provider-badge" }
const _hoisted_15 = { class: "col-score font-weight-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.datasetOptions, (ds) => {
          return (_openBlock(), _createElementBlock("button", {
            key: ds.key,
            class: _normalizeClass(["segment", { active: _ctx.selectedDataset === ds.key }]),
            onClick: ($event: any) => (_ctx.selectedDataset = ds.key)
          }, _toDisplayString(ds.label), 11, _hoisted_4))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("table", _hoisted_6, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", {
              class: "col-model",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.sortBy('displayName')))
            }, [
              _cache[3] || (_cache[3] = _createTextVNode("Model ", -1)),
              (_ctx.sortKey === 'displayName')
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.sortDir === 'asc' ? '\u25B2' : '\u25BC'), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("th", {
              class: "col-provider",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sortBy('provider')))
            }, [
              _cache[4] || (_cache[4] = _createTextVNode("Provider ", -1)),
              (_ctx.sortKey === 'provider')
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.sortDir === 'asc' ? '\u25B2' : '\u25BC'), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("th", {
              class: "col-score",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sortBy('humaneScore')))
            }, [
              _cache[5] || (_cache[5] = _createTextVNode("HumaneScore ", -1)),
              (_ctx.sortKey === 'humaneScore')
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.sortDir === 'asc' ? '\u25B2' : '\u25BC'), 1))
                : _createCommentVNode("", true)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.principleList, (p) => {
              return (_openBlock(), _createElementBlock("th", {
                key: p.id,
                class: "col-principle",
                onClick: ($event: any) => (_ctx.sortBy(p.id))
              }, [
                _createTextVNode(_toDisplayString(p.shortName) + " ", 1),
                (_ctx.sortKey === p.id)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.sortDir === 'asc' ? '\u25B2' : '\u25BC'), 1))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_10))
            }), 128))
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedModels, (model) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: model.id
            }, [
              _createElementVNode("td", _hoisted_12, [
                _createVNode(_component_router_link, {
                  to: { name: 'model-detail', params: { modelId: model.id } },
                  class: "model-link"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(model.displayName), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              _createElementVNode("td", _hoisted_13, [
                _createElementVNode("span", _hoisted_14, _toDisplayString(model.provider), 1)
              ]),
              _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.formatScore(model.scores[_ctx.selectedDataset]['HumaneScore'])), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.principleList, (p) => {
                return (_openBlock(), _createElementBlock("td", {
                  key: p.id,
                  class: "col-principle"
                }, [
                  _createElementVNode("span", {
                    class: "score-cell",
                    style: _normalizeStyle(_ctx.scoreCellStyle(model.scores[_ctx.selectedDataset][p.id]))
                  }, _toDisplayString(_ctx.formatScore(model.scores[_ctx.selectedDataset][p.id])), 5)
                ]))
              }), 128))
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}